/*
 * This file can be used for general library features of noflo-canvas.
 *
 * The library features can be made available as CommonJS modules that the
 * components in this project utilize.
 */
exports.canvas = require("canvas");
